import React from 'react';
import { Box, Button, Container, Flex, Heading, Text } from '@chakra-ui/core';

interface AppCrashFallbackProps {
  onReset: () => void;
}

const AppCrashFallback = ({ onReset }: AppCrashFallbackProps) => {
  const handleBackToHome = () => {
    onReset();
    window.location.assign('/');
  };

  return (
    <Container maxW="md" mt={16}>
      <Box p={8} shadow="lg" borderWidth="1px" borderRadius="xl">
        <Flex direction="column" align="flex-start">
          <Heading fontSize="xl" mb={3}>
            Something went wrong
          </Heading>
          <Text color="gray.500" mb={6}>
            The app hit an unexpected error. Your room is still running —
            rejoining will restore your session.
          </Text>
          <Button colorScheme="purple" onClick={handleBackToHome}>
            Back to home
          </Button>
        </Flex>
      </Box>
    </Container>
  );
};

export default AppCrashFallback;
